import React, { Component, Fragment } from "react";
import { connect } from 'react-redux'

import {CardElement,   PaymentRequestButtonElement, injectStripe} from 'react-stripe-elements';

import { toast } from 'react-toastify';

import classes from './AccountPayForm.module.scss';

import axios from "axios";

const handleBlur = () => {
  console.log('[blur]');
};
const handleChange = (change) => {
  console.log('[change]', change);
};
const handleClick = () => {
  console.log('[click]');
};
const handleFocus = () => {
  console.log('[focus]');
};
const handleReady = () => {
  console.log('[ready]');
};

class AccountPayForm extends Component {
    constructor(props) {
      super(props);

      this.state = {
        amount: 0,
        currency: "",
        clientSecret: null,
        error: null,
        metadata: null,
        disabled: false,
        succeeded: false,
        processing: false
      };

      this.handleSubmit = this.handleSubmit.bind(this);
    }
    
     handleSubmit = async (ev) => {
      // We don't want to let default form submission happen here, which would refresh the page.
      ev.preventDefault();
      this.setState({
        processing:true
      });
      axios
      .post("stripe/createpayment")
      .then(res => {
        console.log(res);
        this.props.stripe.handleCardPayment(res.data.client_secret)
          .then(payload => {
            if (payload.error) {
                toast.error(payload.error.message);
            } else {
                toast.success("Your payment was successfull and your subscription is updated.");
                this.setState({
                  succeeded:true
                });
            }
            this.setState({
              processing:false
            });
          });;
      });

      // You can also use handleCardPayment with the PaymentIntents API.
      // See our handleCardPayment documentation for more:
      // https://stripe.com/docs/stripe-js/reference#stripe-handle-card-payment
      
    };


    render() {
      const { email } = this.props;
      const styles = {
        fontFamily: "'Montserrat', sans-serif",
        fontSize: '16px',
        fontWeight: 'normal'
      }

      let classesContainer = [classes.Container];
     
      if(this.props.isEdit){
        
          classesContainer.push("inedit");
      }

      return (
        <Fragment>
        <p>{ this.props.termes.application.membreAccountCCPhrase}</p>
        <form onSubmit={this.handleSubmit}>
        <div className={classesContainer.join(" ")}>
          { !this.state.succeeded && (
            <Fragment>
           
          <div className={classes.CardFieldContainerOuter}>
            <div  className={classes.CardFieldContainerInner}>
              <CardElement style={{base: styles}} />
            </div>
          </div>
            <button className={ classes.btn } disabled={this.state.disabled}>
                {this.state.processing ? "Processing…" : `${ this.props.termes.application.membreAccountCCButton} ${ this.props.termes.application.membrePrixAnnuel} $US`}
          </button>
          </Fragment>
          )}
          </div>
          </form>
       </Fragment>
      );
    }
}

const mapStateToProps = (state)=>{
  return {
    termes: state.settings.termes
  }
};


export default connect(mapStateToProps)(injectStripe(AccountPayForm));